import styled from 'styled-components';

export const Container = styled.div`
    display: grid;
    gap: 0.3rem;
`;